import React from 'react'
import './ContactUs.css'
import Navbar from './navbar'
import left_img from './images/INDIAMUN/logo left.webp'
import right_img from './images/INDIAMUN/logo right.webp'
import Footer from './footer.js'

const ContactUs = () => {
  const googleFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSec48VUT3RnmbkOcFxbqnvBm415JYLkzZOlI2IGUThkVUam4g/viewform?usp=sharing&ouid=112367709728314115660";

  return (
    <>
      <div className='top_comp'>
        <a href='/'><img className='left_img' src={left_img} alt="India MUN Logo Left" /></a>
        <h2>INDIA’S YOUTH FOR CLIMATE ACTION</h2>
        <img className='right_img' src={right_img} alt="India MUN Logo Right" />
      </div>

      <Navbar />

      <div className="contact-us-page-wrapper">
        <h1 className="contact-us-heading">CONTACT US</h1>
        <p className="contact-us-subheading">
          Have questions, feedback, or want to collaborate with India MUN? Reach out to our team by completing our official contact form.
        </p>

        <div className="contact-us-card">
          <div className="contact-us-icon-wrapper">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#0078e1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>

          <h2 className="contact-us-card-title">Get in Touch</h2>
          <p className="contact-us-card-description">
            Click the button below to open and fill out the official India MUN contact form.
          </p>

          <a
            href={googleFormUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-us-btn"
          >
            Fill Contact Form
            <svg className="btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default ContactUs

